import { useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';

export const useNotificationManager = (setCartNotification, setWishlistNotification) => {
  const hasLoaded = useRef(false);

  useEffect(() => {
    if (!hasLoaded.current) {
      hasLoaded.current = true;
      return;
    }
  }, []);

  useEffect(() => {
    const handleCartNotification = (event) => {
      const { subType, message, item } = event.detail;
      const isMobile = window.innerWidth < 768;

      if (subType === 'remove') {
        toast.success(message, { position: "top-center" });
      } else {
        toast.success(message, { position: "top-center" });
      }

      if (!isMobile) {
        setWishlistNotification(null);
        setCartNotification({ ...item, customMessage: message, id: 'custom' });
        setTimeout(() => setCartNotification(null), 3000);
      }
    };

    window.addEventListener('cartNotification', handleCartNotification);
    return () => window.removeEventListener('cartNotification', handleCartNotification);
  }, [setCartNotification, setWishlistNotification]);

  useEffect(() => {
    const handleWishlistNotification = (event) => {
      const { type, item } = event.detail;
      const isMobile = window.innerWidth < 768;
      
      if (type === 'add') {
        toast.success("Added to Wishlist", { position: "top-center" });
        if (!isMobile) {
          setCartNotification(null);
          setWishlistNotification(item);
          setTimeout(() => setWishlistNotification(null), 3000);
        }
      } else if (type === 'remove') {
        toast.success("Removed from Wishlist", { position: "top-center" });
        if (!isMobile) {
          setWishlistNotification(null);
        }
      }
    };

    window.addEventListener('wishlistNotification', handleWishlistNotification);
    return () => window.removeEventListener('wishlistNotification', handleWishlistNotification);
  }, [setCartNotification, setWishlistNotification]);
};

export default useNotificationManager;